import axios, { AxiosInstance } from "axios";
import { baseUrl, localServiceBaseUrls } from "../config";
import Session from "./session";

const HttpClient: AxiosInstance = axios.create({
  baseURL: baseUrl,
});

HttpClient.interceptors.request.use((config) => {
  const requestUrl = config.url || "";

  // Keep absolute urls untouched.
  if (/^https?:\/\//i.test(requestUrl)) {
    return config;
  }

  const normalizedUrl = requestUrl.replace(/^\/+/, "");
  const matchPrefix = Object.keys(localServiceBaseUrls)
    .sort((a, b) => b.length - a.length)
    .find((prefix) => normalizedUrl.startsWith(prefix));

  if (matchPrefix) {
    config.baseURL = localServiceBaseUrls[matchPrefix];
  }

  const token = Session.getToken();
  if (token && token !== "null" && token !== "undefined" && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const activeOrgId = Session.getActiveOrgId();
  if (activeOrgId && !config.headers["x-active-org-id"]) {
    config.headers["x-active-org-id"] = String(activeOrgId);
  }

  return config;
});

export default HttpClient;
